import axios from "axios";

export const installSessionUnauthorizedInterceptor = (onUnauthorized) => {
  let unauthorizedHandled = false;

  const interceptorId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        error.sessionUnauthorizedHandled = true;
        if (!unauthorizedHandled) {
          unauthorizedHandled = true;
          onUnauthorized();
        }
      }
      return Promise.reject(error);
    },
  );

  return () => axios.interceptors.response.eject(interceptorId);
};
